module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetLow.a91d839.webp";